import { EoLocale, LanguageMap } from '@guest-widgets/shared/src/i18n/i18n';
import sharedEnMessages from '@guest-widgets/shared/src/i18n/locales/en_US.json';

import enMessages from './locales/en_US.json';
import { localesMapper } from './localesMapper';

export const defaultLocale: EoLocale[] = [
  {
    language: 'en-US',
    messages: { ...sharedEnMessages, ...enMessages },
  },
];

export const languageMap: LanguageMap = {
  'en-US': () => Promise.resolve(enMessages),
  ...localesMapper,
};
